import { createContext, useContext, type ReactNode } from 'react';

const ProductionShellContext = createContext(false);

export function ProductionShellProvider({ children }: { children: ReactNode }) {
  return (
    <ProductionShellContext.Provider value>
      {children}
    </ProductionShellContext.Provider>
  );
}

export function useIsInProductionShell() {
  return useContext(ProductionShellContext);
}
